import React from 'react';
import { Section } from './ui/Section';
export function DifferenceSection() {
  return <Section className="bg-white" data-id="element-11">
      <div className="max-w-3xl mx-auto text-center" data-id="element-12">
        <h2 className="text-3xl font-bold text-navy mb-12" data-id="element-13">
          Por qué esto es diferente
        </h2>

        <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-14">
          <div className="bg-stone-50 p-8 rounded-2xl border border-stone-100 opacity-70" data-id="element-15">
            <h3 className="text-lg font-semibold text-navy/60 mb-4 uppercase tracking-wide" data-id="element-16">
              La mayoría de guías
            </h3>
            <p className="text-2xl font-serif italic text-navy/60" data-id="element-17">
              "Haz esto… y ojalá te salga."
            </p>
          </div>

          <div className="bg-green/5 p-8 rounded-2xl border-2 border-green shadow-lg transform md:scale-110 relative z-10" data-id="element-18">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-green text-white px-4 py-1 rounded-full text-xs font-bold uppercase tracking-wider" data-id="element-19">
              Protocolo 10 Días
            </div>
            <h3 className="text-lg font-semibold text-green mb-4 uppercase tracking-wide" data-id="element-20">
              Este Protocolo
            </h3>
            <p className="text-2xl font-serif font-medium text-navy" data-id="element-21">
              "Haz esto. Si pasa esto, ajusta así. Si pasa esto otro, haces
              esto."
            </p>
          </div>
        </div>

        <p className="mt-12 text-lg text-navy/80 font-medium" data-id="element-22">
          Eso es lo que hace que lo puedas sostener. <br data-id="element-23" />
          No es suerte, es sistema.
        </p>
      </div>
    </Section>;
}